import * as React from 'react'
import styled from '@theme/styled-components'

import { Text } from 'react-native'

import LoginForm from '@screens/login/LoginForm'
import SelectRole from '@screens/login/SelectRole'
import ExhibitorView from './ExhibitorView'
import SimpleAlert from '@components/modal/SimpleAlert'

import LoginLayout from './LoginLayout'

import useNavigation from '@layout/useNavigation'
import useI18n from '@i18n/useI18n'
import ForgetPassword from '@screens/login/ForgetPassword'

import { VERSION_NAME } from '@app/config'

const RegisterScreen = () => {
  const [role, setRole] = React.useState<UserRole>()
  const [mode, setMode] = React.useState<'LOGIN' | 'RESET'>('LOGIN')

  const i18n = useI18n()
  const navigation = useNavigation()

  const onBack = () => {
    setRole(undefined)
  }

  const onLoginError = (code?: number) => {
    SimpleAlert.open({
      title: i18n.t(`screens.login.form.errorTitle`),
      description: i18n.t(`screens.login.form.errorSubTitle${code === 400 ? 'WrongInfo' : ''}`),
      buttons: [{ label: i18n.t('common.retry'), onClick: () => SimpleAlert.close() }],
    })
  }

  const onPressForgetPassword = () => {
    setMode('RESET')
  }

  const renderRightView = () => {
    if (mode === 'LOGIN') {
      if (!role) {
        return (
          <>
            <SelectRole onRoleSelected={setRole} />
            <VersionName>{i18n.t('common.version', { version: VERSION_NAME })}</VersionName>
          </>
        )
      } else if (role === 'EXPOSANT') {
        return <ExhibitorView onBack={onBack} onPressForgetPassword={onPressForgetPassword} navigation={navigation} />
      }
      return <LoginForm onBack={onBack} onPressForgetPassword={onPressForgetPassword} onLoginError={onLoginError} />
    }
    return <ForgetPassword onBack={() => setMode('LOGIN')} />
  }

  return <LoginLayout>{renderRightView()}</LoginLayout>
}

export default RegisterScreen

const VersionName = styled(Text)`
  ${(props) => props.theme.fonts.Caption2};
  text-align: center;
  color: ${(props) => props.theme.colors.secondaryText};
  margin: 32px 0;
`
